import { render } from "./icon-disconnect.vue?vue&type=template&id=127a4eb2"
import script from "./icon-disconnect.vue?vue&type=script&lang=js"
export * from "./icon-disconnect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__